/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExcuseStatus } from '../../models/excuse-status';
import { FilteredQuery } from '../../models/filtered-query';
import { GetPlansForInspectorQueryResult } from '../../models/get-plans-for-inspector-query-result';
import { PlanStatus } from '../../models/plan-status';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiPlanGetPlansForInspectorGet$Params {
  Islast?: boolean;
  IsFuture?: boolean;
  IsProject?: boolean;
  IsToday?: boolean;
  Status?: PlanStatus;
  IsWasLate?: boolean;
  ExcuseStatus?: ExcuseStatus;
  From?: string;
  To?: string;
  LocationId?: string;
  Saved?: boolean;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiPlanGetPlansForInspectorGet(http: HttpClient, rootUrl: string, params?: ApiPlanGetPlansForInspectorGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansForInspectorQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanGetPlansForInspectorGet.PATH, 'get');
  if (params) {
    rb.query('Islast', params.Islast, {});
    rb.query('IsFuture', params.IsFuture, {});
    rb.query('IsProject', params.IsProject, {});
    rb.query('IsToday', params.IsToday, {});
    rb.query('Status', params.Status, {});
    rb.query('IsWasLate', params.IsWasLate, {});
    rb.query('ExcuseStatus', params.ExcuseStatus, {});
    rb.query('From', params.From, {});
    rb.query('To', params.To, {});
    rb.query('LocationId', params.LocationId, {});
    rb.query('Saved', params.Saved, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlansForInspectorQueryResult>;
    })
  );
}

apiPlanGetPlansForInspectorGet.PATH = '/api/Plan/GetPlansForInspector';
